import { render, staticRenderFns } from "./OverviewList.vue?vue&type=template&id=00cae28c&scoped=true&"
import script from "./OverviewList.vue?vue&type=script&lang=js&"
export * from "./OverviewList.vue?vue&type=script&lang=js&"
import style0 from "./OverviewList.vue?vue&type=style&index=0&id=00cae28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cae28c",
  null
  
)

export default component.exports